import { render, staticRenderFns } from "./SithMesMstWorkshopLocationEdit.vue?vue&type=template&id=68dbfc90&"
import script from "./SithMesMstWorkshopLocationEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesMstWorkshopLocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports